import { render, staticRenderFns } from "./WaitApproveList.vue?vue&type=template&id=ae96a596&scoped=true"
import script from "./WaitApproveList.vue?vue&type=script&lang=js"
export * from "./WaitApproveList.vue?vue&type=script&lang=js"
import style0 from "./WaitApproveList.vue?vue&type=style&index=0&id=ae96a596&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae96a596",
  null
  
)

export default component.exports